
import {throwError as observableThrowError,  Observable ,  Subject, BehaviorSubject } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import * as moment from 'moment';


import { AppConfigService } from '../../shared/services/app.config.service';
import { IUserProfile } from '../models/User';

let AppConstant: any = {};
@Injectable()
export class AuthenticationService {
    private logger: string;
    private user: string;

    authKey = 'auth';
    token = '';
    redirectUrl = '';
    lockScreen$: BehaviorSubject<any> =  new BehaviorSubject(null);
    resetAuth$: BehaviorSubject<any> =  new BehaviorSubject(null);
    authenticating = false;
    private username = new Subject<any>();

    private _userProfile: IUserProfile = {
        username: null,
        isLoggedIn: false,
        accessToken: null,
        staffId: null
    };

    constructor(
        private http: HttpClient,
        appconfigServ: AppConfigService,
        private router: Router
    ) {
        AppConstant = appconfigServ;
    }

 
 

    
 
    logOut() {
        this._userProfile.isLoggedIn = false;
        sessionStorage.removeItem(this.authKey);
        sessionStorage.removeItem('refreshToken');
        sessionStorage.removeItem('tokenExpiration');
        sessionStorage.removeItem('refreshAt');
        this.unlockScreen();
        // this.removealliteminlocalStore();
    }

    bounceUserOut() {
        this.logOut();
        return this.router.navigate(['/auth/login']);
    }


    // SetUserSpecificTokenAccess(userSpecificTokenAccessEnabled){
    //     this._userProfile.userSpecificTokenAccessEnabled = userSpecificTokenAccessEnabled;
    //     window.sessionStorage.setItem(this.authKey, JSON.stringify(accessToken));
    // }

  


    setNextRefreshTime()   {
        const now   = moment();
        const future = now.add(10, 'minutes');
        const theTime =  future.format('YYYY-MM-DD HH:mm:ss');
        window.sessionStorage.setItem('refreshAt', JSON.stringify(theTime));
    }
    
    setTokenDuration(expires_in) {
        window.sessionStorage.setItem('expires_in', JSON.stringify(expires_in));
    }

    setDateNow(){
        window.sessionStorage.setItem('date_now', JSON.stringify(Date.now()));
    }

    refreshToken()  {

    }

    setUserInfo(info) {
        this._userProfile.staffId = info.staffId;
        this._userProfile.username = info.userName;



        window.sessionStorage.setItem('userInfo', JSON.stringify(info));
        window.sessionStorage.setItem('userInfo', JSON.stringify(info));
        window.sessionStorage.setItem('lastLoggedInUser', info.userName);
        window.sessionStorage.setItem('lastLoggedInUser', info.userName);
    }

    setLoginCode(loginCode){
        window.sessionStorage.setItem('logger', loginCode);
      }

    getLastLoggedInUser() {
        return window.sessionStorage.getItem('lastLoggedInUser');
    }

    setLastLoggedInUser( userName: string) {
      window.sessionStorage.setItem('lastLoggedInUser', userName);
      window.sessionStorage.setItem('lastLoggedInUser', userName);
    }

    removealliteminlocalStore() {
        sessionStorage.clear();
        sessionStorage.clear();
    }






    getnextTimeToRefreshToken() {
        const time =  moment(JSON.parse(window.sessionStorage.getItem('refreshAt')));
        const now  = moment();
       // console.log( moment(time));
        // console.log( now);
        // console.log( time > now ? 'yes' : 'no');
        // console.log( time.isSameOrAfter(now) ? 'yes' : 'no');
        if (time) { return time; } else {
            return null;
        }
    }


    lockScreen() {
      sessionStorage.setItem('lockScreen','1');
    }
    screenWaslocked() {
      return  sessionStorage.getItem('lockScreen');
    }

    unlockScreen() {
      sessionStorage.removeItem('lockScreen');
    }

    get lastUsername(): Observable<string> {
        return this.username.asObservable();
    }

    setLastUsername(username: string) {
        this.username.next(username);
    }

 

    getToken() {
        try{
            this.token = JSON.parse(window.sessionStorage.getItem(this.authKey));
            return this.token;
        }
        catch{
            this.bounceUserOut();
        }
        
    }

    getRefreshToken() {
        let refreshToken = JSON.parse(window.sessionStorage.getItem('refreshToken'));
        return refreshToken;
    }

    getLoggedInUser() {
        return JSON.parse(window.sessionStorage.getItem(this.authKey));
    }

    setLoggedInUser(accessToken) {
        this._userProfile.accessToken = accessToken;
        this._userProfile.isLoggedIn = true;
        window.sessionStorage.setItem(this.authKey, JSON.stringify(accessToken));
    }

    setRefreshToken(refreshToken) {
        window.sessionStorage.setItem('refreshToken', JSON.stringify(refreshToken));
    }

 

    setLoggedInUserActivities(activities) {
        window.sessionStorage.setItem('userActivities', JSON.stringify(activities));
        let activites = btoa(JSON.stringify(activities));
        window.sessionStorage.setItem('encrypt', activites);
    }

    getLoggedInUserActivities() {
        return JSON.parse(window.sessionStorage.getItem('userActivities'));
    }

    getUserInfo() {
        return JSON.parse(window.sessionStorage.getItem('userInfo'));
    }

    setTokenExpirationTime(expDate) {
        

        window.sessionStorage.setItem('tokenExpiration', JSON.stringify(expDate));
    }

    getTokenExpirationTime() {
        return JSON.parse(window.sessionStorage.getItem('tokenExpiration'));
    }

    isUserLoggedIn(): boolean {
        if (window.sessionStorage.getItem(this.authKey)) {
            return true;
        } else {
            return false;
        }
    }

    signInWithToken(userParams, token) {
        let bodyObj = JSON.stringify(userParams);
        return this.http.post(`${AppConstant.API_BASE}auth/token`, bodyObj, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
            .set('Authorization','Bearer ' + token )
        }).pipe(
            map((res: any) => res),
            catchError((error: any) =>  {
                return observableThrowError(error.msg || error.error.message || error.error.error_description || 'Server error. Please contact your administrator');}));
    }

    getAuthToken(username, password) {
        let body = `username=${username}&password=${password}&grant_type=password`;
         
        return this.http.post(AppConstant.TOKEN_URL, body, 
            {headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        }).pipe(
            map((res: any) => res),
            catchError((error: any) =>  {
               return observableThrowError(error.msg || error.error.message || error.error.error_description || 'Server error. Please contact your administrator');}));
    }

    validateUserCredentials(username: string, password) {
        const body = { username, password};
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post(`${AppConstant.API_BASE}auth/validate-login`, body, { headers })
            .pipe(
            map((res: any) => res),
            catchError((error: any) =>
            observableThrowError(() => error || 'Server error. Please contact your administrator')
        ));
    }
    
    getClearSessionAuthToken(username, password) {
        let body = `username=${username}&password=${password}&grant_type=password`;
        // const headers = new HttpHeaders();
        // headers.set('Content-Type', 'x-www-form-urlencoded');
        // const options =  { headers };
  
        return this.http.post(AppConstant.TOKEN_URL, body, {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        })
        .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error ||  'Server error. Please contact your adminstrator')
        ));
    }

    getAuthRefreshToken(username, refreshToken) {
        let body = `username=${username}&refresh_token=${refreshToken}&grant_type=refresh_token`;
       
        return this.http.post(AppConstant.TOKEN_URL, body, {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        }).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error.message || error.error.error_description || 'Server error. Please contact your administrator')));
    }

    setLastTokenRefreshTime(){
        this.setLastTokenRefreshTimeSrv().subscribe((res: any) => {
          if (res.result == true){

            }}
         )}

    setLastTokenRefreshTimeSrv(){
        const body = {};
        return this.http.post(`${AppConstant.API_BASE}auth/set-token-refresh-time`, body,{
            headers: new HttpHeaders().set('Authorization', `Bearer ${this.token}`)
            .set('Content-Type', 'application/json')
            .set('logger', this.logger)
            .set('user', this.user)
        })
          .pipe(
            map((res: Response) =>  res),
            catchError((error: any) => observableThrowError(error ||  'Server error. Please contact your adminstrator')
          ));
    }

    get UserProfile(): IUserProfile {
        return this._userProfile;
    }

    setUserProfile(username: string, token: string) {
        this._userProfile.username = username;
        this._userProfile.accessToken = token;
        this._userProfile.isLoggedIn = true;
    }

    logOffSystem() {
        let bodyObj = {};
        this.logger = window.sessionStorage.getItem('logger') != null ? window.sessionStorage.getItem('logger') : "";
        this.user = window.sessionStorage.getItem('lastLoggedInUser') != null ? window.sessionStorage.getItem('lastLoggedInUser') : "";

        return this.http.post(`${AppConstant.API_BASE}auth/logOut`, bodyObj, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.token)
            .set('logger', this.logger)
            .set('user', this.user)
        }).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error_description || 'Server error. Please contact your administrator')),);
    }

    logOffIdle() {
        let bodyObj = {};
        this.logger = window.sessionStorage.getItem('logger') != null ? window.sessionStorage.getItem('logger') : "";
        this.user = window.sessionStorage.getItem('lastLoggedInUser') != null ? window.sessionStorage.getItem('lastLoggedInUser') : "";
    
        return this.http.post(`${AppConstant.API_BASE}auth/logout-idle`, bodyObj, 
        {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.token)
            .set('logger', this.logger)
            .set('user', this.user)
        }).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error_description || 'Server error. Please contact your administrator')),);
    }
        
    endActiveSession(userParams) {
        let bodyObj = JSON.stringify(userParams);
        this.logger = window.sessionStorage.getItem('logger') != null ? window.sessionStorage.getItem('logger') : "";
        this.user = window.sessionStorage.getItem('lastLoggedInUser') != null ? window.sessionStorage.getItem('lastLoggedInUser') : "";

        return this.http.post(`${AppConstant.API_BASE}auth/endpendingsession`, bodyObj, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.token)
            .set('logger', this.logger)
            .set('user', this.user)
        }).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.message ||  error.error_description || 'Server error. Please contact your administrator')),);
    }

    passwordChange(data) {
        let bodyObj = JSON.stringify(data);
        this.logger = window.sessionStorage.getItem('logger') != null ? window.sessionStorage.getItem('logger') : "";
        this.user = window.sessionStorage.getItem('lastLoggedInUser') != null ? window.sessionStorage.getItem('lastLoggedInUser') : "";

        return this.http.post(`${AppConstant.API_BASE}auth/passwordchange`, bodyObj, {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.token)
            .set('logger', this.logger)
            .set('user', this.user)

        }).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.message ||  error.error_description || 'Server error. Please contact your administrator')),);
    }

    verifyCorr(): boolean {
        if (this.getUserInfo().corrMatrixId > 0 && this.getUserInfo().corrMatrixId == 4) {
            return false;
        }
        return true;
    }

    refreshExpiredToken(): Observable<any> {
        const userInfo = this.getUserInfo();
        const refreshToken = this.getRefreshToken();
        const obs =  new Observable((observer) => {
          this.getAuthRefreshToken(userInfo.userName, refreshToken).subscribe((response: any) => {
            this.logOut();
            this.setLoggedInUser(response.access_token);
            this.setTokenExpirationTime(response.expiry_date);
            this.setRefreshToken(response.refresh_token);
  
            observer.next(response.access_token);
            observer.complete();
            this.setLastTokenRefreshTime();
        }, (error) => {
          observer.error(error);
          observer.complete();
        });
    });
  
        return obs;
    }

    validateLoginSession() {
        this.logger = window.sessionStorage.getItem('logger') != null ? window.sessionStorage.getItem('logger') : "";
        this.user = window.sessionStorage.getItem('lastLoggedInUser') != null ? window.sessionStorage.getItem('lastLoggedInUser') : "";
        const body = {
          user: this.user,
          loginCode: this.logger
        }
        return this.http.post(`${AppConstant.API_BASE}auth/validxxx`,body,{
            headers: new HttpHeaders().set('Authorization', `Bearer ${this.token}`)
        })
          .pipe(
            map((res: Response) => res),
            catchError((error: any) => observableThrowError(error ||  'Server error. Please contact your adminstrator')
          ));
      }
}